export function inputPlaceholders(){
    let inputs = $(".with-label");

    inputs.addClass("placeholder-shown");

    inputs.focus(function (){
        $(this).addClass("focus");
    });

    inputs.blur(function (){
        if($(this).val().length == 0){
            $(this).removeClass("focus").addClass("placeholder-shown");
        }
    });

    $( ".datepicker" ).datepicker();

    document.addEventListener('DOMContentLoaded', function() {
        const select = document.querySelector('.jcf-select');

        function updateDropdownWidth() {
            const dropdownContent = document.querySelector('.jcf-select-drop .jcf-select-drop-content');

            if (dropdownContent && select) {
                const selectWidth = select.offsetWidth;
                dropdownContent.style.width = `${selectWidth}px`;
            }
        }

        const observer = new MutationObserver(function(mutationsList, observer) {
            const dropdownContent = document.querySelector('.jcf-select-drop .jcf-select-drop-content');

            if (dropdownContent) {
                updateDropdownWidth();
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        window.addEventListener('resize', updateDropdownWidth);
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/inputs.js